import { useEffect, useState } from 'react';
import useRequest from '@/websdk/utils/request';
import { useDevExtraHiveSnByLine } from '@/server';
import { MqttApi } from '@/utils/paho_mqtt';
import uuid from 'react-uuid';

const apis = {
  getAuxiliarys: {
    name: 'GET_WORKLINE_ENERGY_AUXILIARYS',
    key: 'monitor/auxiliarys',
    defaultValue: [],
  },
  getEnergyConsumption: {
    name: 'GET_WORKLINE_ENERGY_CONSUMPTION',
    key: 'monitor/energy-consumption',
    defaultValue: {},
  },
  getProductionsCurrent: {
    name: 'GET_WORKLINE_PRODUCTIONS_CURRENT',
    key: 'productions/current',
    defaultValue: {},
  },
  getProductsCurrent: {
    name: 'GET_WORKLINE_PRODUCTS_CURRENT',
    key: 'products/current',
    defaultValue: {},
  },
  getRealTimeInfo: {
    name: 'GET_WORKLINE_REAL_TIME_INFO',
    key: 'monitor/real-time-info',
    defaultValue: {},
  },
  getHistoryTempMonitor: {
    name: 'GET_WORKLINE_HISTORY_TEMP_MONITOR',
    key: 'history/temperature-monitor',
    defaultValue: {},
  },
  getDriverMonitor: {
    name: 'GET_WORKLINE_DRIVER_MONITOR',
    key: 'history/driver-monitor',
    defaultValue: {},
  },
  getPreview: {
    name: 'GET_WORKLINE_REAL_TIME_INFO',
    key: 'group/preview',
    defaultValue: {},
  },
  getHistoryQualityMonitor: {
    name: 'GET_WORKLINE_HISTORY_QUALITY_MONITOR',
    key: 'history/quality-monitor',
    defaultValue: {},
  },
  getHistoryParamChange: {
    name: 'GET_WORKLINE_HISTORY_PARAM_CHANGE',
    key: 'history/param-change',
    defaultValue: {},
  },
  getHistoryAlarms: {
    name: 'GET_WORKLINE_HISTORY_ALARMS',
    key: 'history/alarms',
    defaultValue: {},
  },
  getMaintain: {
    name: 'GET_WORKLINE_MAINTAIN',
    key: 'maintain',
    defaultValue: [],
  },
};

export { apis };

export default function (lineId, api, params) {
  const { data, exec } = useRequest({
    url: '',
    name: api.name,
    manual: true,
  });

  const page_uid = uuid();
  const [machid, setMachid] = useState();
  const [hiveSn, isHiveSnSuccess] = useDevExtraHiveSnByLine(machid);
  useEffect(() => {
    if (isHiveSnSuccess) {
      if (hiveSn) {
        if (hiveSn === 'hive_not_alive') {
          setRsp(api.defaultValue);
          return;
        }
        switch (api.key) {
          case 'history/quality-monitor':
            MqttApi.subscriptionApi(
              {
                topic: 'production_unit_quality-monitor-rsp-' + hiveSn + '-' + page_uid,
              },
              res => {
                //console.log('resqua', res);
                if (!res.data.error) {
                  setRsp(res.data.data);
                } else {
                  setRsp(api.defaultValue);
                }
              }
            );
            MqttApi.publishApi({
              topic: 'production_unit_quality-monitor-req-' + hiveSn,
              payload: {
                line_id: lineId,
                start: params ? (params.start ? params.start : 0) : 0,
                end: params ? (params.end ? params.end : 0) : 0,
                id: page_uid,
              },
            });
            break;
          case 'history/temperature-monitor':
            MqttApi.subscriptionApi(
              {
                topic: 'production_unit_temperature-monitor-rsp-' + hiveSn + '-' + page_uid,
              },
              res => {
                //console.log('restemp', res);
                if (!res.data.error) {
                  setRsp(res.data.data);
                } else {
                  setRsp(api.defaultValue);
                }
              }
            );
            MqttApi.publishApi({
              topic: 'production_unit_temperature-monitor-req-' + hiveSn,
              payload: {
                line_id: lineId,
                start: params ? (params.start ? params.start : 0) : 0,
                end: params ? (params.end ? params.end : 0) : 0,
                id: page_uid,
              },
            });
            break;
          case 'history/alarms':
            MqttApi.subscriptionApi(
              {
                topic: 'production_unit_alarm-rsp-' + hiveSn + '-' + page_uid,
              },
              res => {
                //console.log('resalarm', res);
                if (!res.data.error) {
                  setRsp(res.data.data);
                } else {
                  setRsp(api.defaultValue);
                }
              }
            );
            MqttApi.publishApi({
              topic: 'production_unit_alarm-req-' + hiveSn,
              payload: {
                line_id: lineId,
                id: page_uid,
              },
            });
            break;
          case 'history/param-change':
            MqttApi.subscriptionApi(
              {
                topic: 'production_unit_param-update-rsp-' + hiveSn + '-' + page_uid,
              },
              res => {
                //console.log('resparam', res);
                if (!res.data.error) {
                  setRsp(res.data.data);
                } else {
                  setRsp(api.defaultValue);
                }
              }
            );
            MqttApi.publishApi({
              topic: 'production_unit_param-update-req-' + hiveSn,
              payload: {
                line_id: lineId,
                id: page_uid,
              },
            });
            break;
          case 'monitor/real-time-info':
            MqttApi.subscriptionApi(
              {
                topic: 'real-time-info-rsp-' + hiveSn + '-' + page_uid,
              },
              res => {
                //console.log('resparam', res);
                if (!res.data.error) {
                  setRsp(res.data.data);
                } else {
                  setRsp(api.defaultValue);
                }
              }
            );
            MqttApi.publishApi({
              topic: 'real-time-info-req-' + hiveSn,
              payload: {
                line_id: lineId,
                id: page_uid,
              },
            });
            break;
          case 'monitor/auxiliarys':
            MqttApi.subscriptionApi(
              {
                topic: 'auxiliarys-info-rsp-' + hiveSn + '-' + page_uid,
              },
              res => {
                //console.log('resparam', res);
                if (!res.data.error) {
                  setRsp(res.data.data);
                } else {
                  setRsp(api.defaultValue);
                }
              }
            );
            MqttApi.publishApi({
              topic: 'auxiliarys-info-req-' + hiveSn,
              payload: {
                line_id: lineId,
                id: page_uid,
              },
            });
            break;
          case 'monitor/energy-consumption':
            MqttApi.subscriptionApi(
              {
                topic: 'energy-consumption-rsp-' + hiveSn + '-' + page_uid,
              },
              res => {
                //console.log('resparam', res);
                if (!res.data.error) {
                  setRsp(res.data.data);
                } else {
                  setRsp(api.defaultValue);
                }
              }
            );
            MqttApi.publishApi({
              topic: 'energy-consumption-req-' + hiveSn,
              payload: {
                line_id: lineId,
                id: page_uid,
              },
            });
            break;
          default:
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hiveSn, isHiveSnSuccess]);

  const manualRequest = function () {
    if (lineId) {
      if (
        localStorage.model === '2' &&
        (api.key === 'history/param-change' ||
          api.key === 'history/alarms' ||
          api.key === 'history/temperature-monitor' ||
          api.key === 'history/quality-monitor' ||
          api.key === 'monitor/real-time-info' ||
          api.key === 'monitor/auxiliarys' ||
          api.key === 'monitor/energy-consumption')
      ) {
        setMachid({ line_id: lineId });
      } else {
        let url = `/api/worklines/${lineId}/${api.key}${
          api.key === 'history/param-change' ? '?is_production_unit=1' : ''
        }`;
        if (
          api.key === 'history/temperature-monitor' ||
          api.key === 'history/quality-monitor' ||
          api.key === 'history/driver-monitor'
        ) {
          url = `/api/worklines/${lineId}/${api.key}`;
          if (params) {
            Object.keys(params).forEach((key, index) => {
              if (index === 0) {
                url += '?';
              } else {
                url += '&';
              }
              url += `${key}=${params[key]}`;
            });
          }
        }
        exec(url);
      }
    }
  };

  const [rsp, setRsp] = useState();
  useEffect(() => {
    if (data) {
      setRsp(data);
    }
  }, [data]);

  useEffect(() => {
    manualRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineId, params]);

  return [rsp || api.defaultValue, manualRequest];
}
